<template>
  <v-data-table
    :loading="loading"
    :search="search"
    :items="items"
    :headers="headers"
    :no-data-text="$t('no_data')"
    class="elevation-1 mt-3"
    :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
  >
   <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
    <template
      v-slot:item.no="{ item }"
    >{{items.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
    <template
      v-slot:item.minimum="{ item }"
    >{{toNumeral(item.minimum)}}</template>
    <template
      v-slot:item.maximum="{ item }"
    >{{toNumeral(item.maximum)}}</template>
    <template
      v-slot:item.ptkp="{ item }"
    >{{toNumeral(item.ptkp)}}</template>
  </v-data-table>
</template>
<script>
import numeral from 'numeral'

export default {
  name: 'TableComponent',
  props: ['loading', 'search', 'items', 'headers'],
  methods: {
    toNumeral(number) {
      return numeral(number).format("0,0");
    },
  }
}
</script>
